/**
 * Read off the token because the SDK does not surface them. Not verification
 * -- this only decides which routes to offer, and the API enforces again.
 */
export function scopesFromToken(token: string | null | undefined): string[] {
  if (!token) {
    return [];
  }

  const payload = token.split('.')[1];
  if (!payload) {
    return [];
  }

  try {
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const scope = (JSON.parse(json) as { scope?: string }).scope;
    return scope ? scope.split(' ') : [];
  } catch {
    return [];
  }
}
